import { axios, API } from './config';

export const inventoryAPI = {
  getAll: async (category = null, lowStockOnly = false) => {
    const params = {};
    if (category) params.category = category;
    if (lowStockOnly) params.low_stock_only = true;
    const response = await axios.get(`${API}/inventory`, { params });
    return response.data;
  },
  
  getById: async (equipmentId) => {
    const response = await axios.get(`${API}/inventory/${equipmentId}`);
    return response.data;
  },
  
  initialize: async () => {
    const response = await axios.post(`${API}/inventory/init`);
    return response.data;
  },
  
  update: async (equipmentId, data) => {
    const response = await axios.put(`${API}/inventory/${equipmentId}`, data);
    return response.data;
  },
  
  checkout: async (equipmentId, quantity, contractId, eventName) => {
    const response = await axios.post(`${API}/inventory/checkout`, null, {
      params: { equipment_id: equipmentId, quantity, contract_id: contractId, event_name: eventName }
    });
    return response.data;
  },
  
  returnItems: async (equipmentId, quantity, contractId = null) => {
    const params = { equipment_id: equipmentId, quantity };
    if (contractId) params.contract_id = contractId;
    const response = await axios.post(`${API}/inventory/return`, null, { params });
    return response.data;
  },
  
  getLogs: async (equipmentId = null, limit = 50) => {
    const params = { limit };
    if (equipmentId) params.equipment_id = equipmentId;
    const response = await axios.get(`${API}/inventory/logs`, { params });
    return response.data;
  },
  
  getAlerts: async () => {
    const response = await axios.get(`${API}/inventory/alerts`);
    return response.data;
  },
  
  // New P2 enhancements
  restock: async (equipmentId, quantity = null) => {
    const params = quantity !== null ? { quantity } : {};
    const response = await axios.post(`${API}/inventory/restock/${equipmentId}`, null, { params });
    return response.data;
  },
  
  reserveForContract: async (contractId) => {
    const response = await axios.post(`${API}/inventory/reserve-for-contract/${contractId}`);
    return response.data;
  },
  
  releaseForContract: async (contractId) => {
    const response = await axios.post(`${API}/inventory/release-for-contract/${contractId}`);
    return response.data;
  },
  
  getUsageReport: async (startDate = null, endDate = null) => {
    const params = {};
    if (startDate) params.start_date = startDate;
    if (endDate) params.end_date = endDate;
    const response = await axios.get(`${API}/inventory/usage-report`, { params });
    return response.data;
  },
  
  exportInventory: async () => {
    const response = await axios.get(`${API}/inventory/export`);
    return response.data;
  }
};
